(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-parts-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-parts-gallery')) {
  customElements.define('product-parts-gallery', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.resize?.disconnect();
      this.track = this.querySelector('[data-part-track]');
      this.track.querySelectorAll('[data-part-clone]').forEach(part => part.remove());
      this.parts = Array.from(this.track.querySelectorAll('[data-part-index]'));
      if (!this.parts.length) return;
      this.viewport = this.querySelector('.sm-parts-gallery__viewport');
      this.number = this.querySelector('[data-part-number]');
      this.previous = this.querySelector('[data-part-previous]');
      this.next = this.querySelector('[data-part-next]');
      this.index = Math.max(0, this.parts.findIndex(part => part.getAttribute('aria-pressed') === 'true'));
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.setZoom(false);
      this.gesture = null;
      this.suppressClickUntil = 0;
      this.addEventListener('click', event => {
        if (event.detail > 0 && performance.now() < this.suppressClickUntil) {
          event.preventDefault();
          return;
        }
        const part = event.target.closest('[data-part-index]');
        if (part && this.contains(part)) {
          if (part === this.parts[this.index]) {
            this.setZoom(!this.hasAttribute('data-part-zoomed'));
          } else {
            this.move(Math.round((part.offsetLeft - this.parts[this.index].offsetLeft) / this.step), true);
          }
        }
        if (event.target.closest('[data-part-previous]')) this.move(-1);
        if (event.target.closest('[data-part-next]')) this.move(1);
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.hasAttribute('data-part-zoomed')) {
          this.setZoom(false);
          return;
        }
        if (event.altKey || event.ctrlKey || event.metaKey || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        if (!event.target.closest('.sm-parts-gallery__navigation')) return;
        event.preventDefault();
        event.stopPropagation();
        this.move(event.key === 'ArrowRight' ? 1 : -1, true);
      }, options);
      this.viewport.addEventListener('pointerdown', event => this.startSwipe(event), options);
      this.viewport.addEventListener('pointermove', event => this.updateSwipe(event), options);
      this.viewport.addEventListener('pointerup', event => this.endSwipe(event), options);
      this.viewport.addEventListener('pointercancel', event => this.endSwipe(event, true), options);
      this.viewport.addEventListener('lostpointercapture', event => {
        if (event.target === this.viewport) this.endSwipe(event, true);
      }, options);
      this.buildLoop();
      this.resize = new ResizeObserver(() => {
        if (this.viewport.clientWidth !== this.viewportWidth) this.buildLoop();
      });
      this.resize.observe(this.viewport);
    }
    disconnectedCallback() {
      this.events?.abort();
      this.resize?.disconnect();
    }
    setZoom(zoomed) {
      this.toggleAttribute('data-part-zoomed', zoomed);
      this.parts.forEach((part, i) => {
        const selected = i === this.index;
        part.setAttribute('aria-expanded', String(selected && zoomed));
        part.querySelector('img').sizes = selected ? (zoomed ? '250px' : '150px') : '100px';
      });
    }
    startSwipe(event) {
      if (event.pointerType === 'mouse') return;
      if (!event.isPrimary) {
        if (this.gesture) this.endSwipe({ pointerId: this.gesture.id }, true);
        return;
      }
      this.suppressClickUntil = 0;
      this.gesture = { id: event.pointerId, x: event.clientX, y: event.clientY, dx: 0, horizontal: false };
    }
    updateSwipe(event) {
      const gesture = this.gesture;
      if (!gesture || event.pointerId !== gesture.id) return;
      const dx = event.clientX - gesture.x;
      const dy = event.clientY - gesture.y;
      if (!gesture.horizontal) {
        if (Math.max(Math.abs(dx), Math.abs(dy)) < 10) return;
        if (Math.abs(dy) >= Math.abs(dx)) {
          this.gesture = null;
          return;
        }
        gesture.horizontal = true;
        this.viewport.setPointerCapture(event.pointerId);
        this.setAttribute('data-part-dragging', '');
      }
      gesture.dx = dx;
      this.track.style.setProperty('--sm-parts-drag', `${Math.max(-this.step, Math.min(this.step, dx))}px`);
    }
    endSwipe(event, cancelled = false) {
      const gesture = this.gesture;
      if (!gesture || event.pointerId !== gesture.id) return;
      this.gesture = null;
      this.removeAttribute('data-part-dragging');
      this.track.style.setProperty('--sm-parts-drag', '0px');
      if (this.viewport.hasPointerCapture(gesture.id)) this.viewport.releasePointerCapture(gesture.id);
      if (!gesture.horizontal) return;
      this.suppressClickUntil = performance.now() + 400;
      if (!cancelled && Math.abs(gesture.dx) >= 32) this.move(gesture.dx < 0 ? 1 : -1);
    }
    buildLoop() {
      this.track.querySelectorAll('[data-part-clone]').forEach(part => part.remove());
      this.viewportWidth = this.viewport.clientWidth;
      this.step = this.parts.length > 1
        ? this.parts[1].offsetLeft - this.parts[0].offsetLeft
        : this.parts[0].offsetWidth + parseFloat(getComputedStyle(this.track).columnGap || 0);
      if (this.parts.length > 1) {
        const copies = Math.max(1, Math.ceil(this.viewportWidth / (this.step * this.parts.length)));
        const before = document.createDocumentFragment();
        const after = document.createDocumentFragment();
        for (let copy = 0; copy < copies; copy++) {
          for (const part of this.parts) {
            for (const fragment of [before, after]) {
              const clone = part.cloneNode(true);
              clone.dataset.partClone = '';
              clone.setAttribute('aria-hidden', 'true');
              clone.setAttribute('aria-pressed', 'false');
              clone.setAttribute('aria-expanded', 'false');
              clone.tabIndex = -1;
              clone.querySelector('img').loading = 'eager';
              fragment.append(clone);
            }
          }
        }
        this.track.prepend(before);
        this.track.append(after);
      }
      this.track.style.transition = 'none';
      this.track.style.setProperty('--sm-parts-offset', `${-this.parts[this.index].offsetLeft}px`);
      void this.track.offsetWidth;
      this.track.style.transition = '';
      this.updateSelection();
    }
    updateSelection(focus = false) {
      this.parts.forEach((part, i) => {
        part.setAttribute('aria-pressed', String(i === this.index));
        part.tabIndex = i === this.index ? 0 : -1;
      });
      const selected = this.parts[this.index];
      const partName = selected.dataset.partName || '';
      this.number.textContent = partName;
      this.number.hidden = !partName;
      this.previous.disabled = this.next.disabled = this.parts.length < 2;
      if (focus) this.parts[this.index].focus({ preventScroll: true });
    }
    move(delta, focus = false) {
      if (this.parts.length < 2 || !delta) return;
      const nextIndex = ((this.index + delta) % this.parts.length + this.parts.length) % this.parts.length;
      const target = this.parts[nextIndex].offsetLeft;
      const wrappedDistance = this.parts[this.index].offsetLeft + delta * this.step - target;
      if (wrappedDistance) {
        const current = new DOMMatrixReadOnly(getComputedStyle(this.track).transform).m41;
        this.track.style.transition = 'none';
        this.track.style.setProperty('--sm-parts-offset', `${current + wrappedDistance}px`);
        void this.track.offsetWidth;
        this.track.style.transition = '';
      }
      this.index = nextIndex;
      this.setZoom(false);
      this.updateSelection(focus);
      this.track.style.setProperty('--sm-parts-offset', `${-target}px`);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
